import RulesPanel from './RulesPanel';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { backupRules, restoreRules } from 'redux/rules/RulesActions';
import { addRuleIdsToProfile } from 'redux/profiles/ProfilesActions';

const mapStateToProps = ({ rules, profiles }) => ({
  rules: rules.rules,
  orderedRules: rules.orderedRules,
  profileRules: profiles.profile.ruleSets,
  orderHasChanged: rules.orderHasChanged,
  fetchingRules: rules.fetchingRules
});

const mapDispatchToProps = dispatch => ({
  rulesActions: bindActionCreators({ restoreRules, backupRules }, dispatch),
  profilesActions: bindActionCreators({ addRuleIdsToProfile }, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(RulesPanel);



// WEBPACK FOOTER //
// ./src/components/importProfile/comp/rulesPanel/RulesPanelConnector.js